import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { coloBlindnessOption, visualAcuityTest } from './formOptions'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController'
import { ParentContainerSection } from '../DiabeticForm'

const VisualAcuityTest = (props) => {
    const { control, errors } = props

    const visualAcuityTestArr=[
        {label:"L", formFieldName:"visual_acuity_left", option: visualAcuityTest },
        {label:"R", formFieldName:"visual_acuity_right", option: visualAcuityTest },
    ]

  return (
    <ParentContainerSection  heading="Section F: Uncorrected Visual Acuity Test">
        <TableContainer component={Paper} sx={{ mb: "1rem" }}>
      <Table sx={{ maxWidth: 450, '& td, & th': { border: '0.5px solid lightgray' } }} aria-label="visual acuity table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}></TableCell>
            <TableCell align="left">6/6</TableCell>
            <TableCell align="left">6/9</TableCell>
            <TableCell align="left">6/12</TableCell>
            <TableCell align="left">6/18</TableCell>
            <TableCell align="left">6/24</TableCell>
            <TableCell align="left">6/36</TableCell>
            <TableCell align="left">6/60</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {visualAcuityTestArr.map((visualAcuity,index)=>(
            <TableRow key={index}>
            <TableCell>{visualAcuity.label}</TableCell>
            {visualAcuity.option.map((item, optionInd)=>(
                <TableCell align="right" key={optionInd}>
                <RadioButtonController 
                                name={visualAcuity.formFieldName}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={[item]}
                                isMargin={false}
                                isDisabled={true}
                            />
                            </TableCell>
            ))}
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </TableContainer>
    </ParentContainerSection>
  )
}

export default VisualAcuityTest